<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row>
          <a-col :md="7" :sm="8">
            <a-form-item
              :label="$t(I18N_KEY.CUSTTRANS + 'requestDate')"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 14, offset: 1 }"
            >
              <a-range-picker v-model="queryParam.examineDate" format="DD-MM-YYYY" />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="8" :sm="8">
            <a-form-item :label="$t(I18N_KEY.CUSTTRANS + 'productType')">
              <a-select mode="multiple" v-model="queryParam.appSsids">
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                $t('reset')
              }}</a-button>
              <!-- <a-button type="primary" @click="download" icon="export" style="margin-left: 8px">{{
                $t('exportFile')
              }}</a-button> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :scroll="{ x: 'max-content' }"
        bordered
        @change="handleTableChange"
      >
      </a-table>
      <div style="margin-top: 15px; text-align: right">
        <v-pagination
          v-if="total"
          :page-num="form.pageNum"
          :page-size="form.pageSize"
          :total="total"
          @change="handleTableChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import moment from 'moment'
import { getApplist } from '@/webpublicapi/order'
import { getReportDay } from '@/webpublicapi/custTrans'
import exportFile from '@/webpublicapi/exportFile'

const I18N_KEY = {
  OASYSTEM: 'oaSystem.',
  CUSTTRANS: 'custTrans.',
}
export default {
  name: 'register',
  components: {},
  data() {
    return {
      I18N_KEY,
      visible: false,
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      appList: [],
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      dataSource: [],
      oaWorkplaceNames: [],
      // Query conditions
      queryParam: {
        examineDate: [moment().add('days', -15), moment().add('days', 0)],
        appSsids: '',
        type: 1,
      },
      loading: false,
      // Table header
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 },
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('custTrans.requestDate'),
          align: 'left',
          dataIndex: 'statisticDate',
          width: '150px',
        },
        // {
        //   title: 'APP',
        //   align: 'left',
        //   dataIndex: 'appSsid',
        //   width: '150px',
        // },
        {
          title: this.$t('custTrans.installNum'),
          align: 'left',
          dataIndex: 'installNum',
          width: '150px',
        },
        {
          title: this.$t('custTrans.transRate'),
          align: 'left',
          dataIndex: 'transRate',
          width: '150px',
        },
        {
          title: this.$t('custTrans.regSubMobileDistinctNum'),
          align: 'left',
          dataIndex: 'subMobileDistinctNum',
          width: '150px',
        },
        {
          title: this.$t('custTrans.regSubMobileNum'),
          align: 'left',
          dataIndex: 'subMobileNum',
          width: '150px',
        },
        {
          title: this.$t('custTrans.avgSubNum'),
          align: 'left',
          dataIndex: 'avgSubNum',
          width: '150px',
        },
        {
          title: this.$t('custTrans.regSubValidMobileDistinctNum'),
          align: 'left',
          dataIndex: 'subValidMobileDistinctNum',
          width: '150px',
        },
        {
          title: this.$t('custTrans.subValidMobileProportion'),
          align: 'left',
          dataIndex: 'subValidMobileProportion',
          width: '150px',
        },
        {
          title: this.$t('custTrans.regSendOtpNum'),
          align: 'left',
          dataIndex: 'sendOtpNum',
          width: '150px',
        },
        {
          title: this.$t('custTrans.regSendOtpMobileDistinctNum'),
          align: 'left',
          dataIndex: 'sendOtpMobileDistinctNum',
          width: '150px',
        },
        {
          title: this.$t('custTrans.avgSendNumEveryMobile'),
          align: 'left',
          dataIndex: 'avgSendNumEveryMobile',
          width: '150px',
        },
        {
          title: this.$t('custTrans.regOperateSucceedNum'),
          align: 'left',
          dataIndex: 'operateSucceedNum',
          width: '150px',
        },
        {
          title: this.$t('custTrans.regOperateFailNum'),
          align: 'left',
          dataIndex: 'operateFailNum',
          width: '150px',
        },
        {
          title: this.$t('custTrans.unLoginNum'),
          align: 'left',
          dataIndex: 'unLoginNum',
          width: '150px',
        },
        {
          title: this.$t('custTrans.lockOtpNum'),
          align: 'left',
          dataIndex: 'lockOtpNum',
          width: '150px',
        },
        {
          title: this.$t('custTrans.regLockOperateNum'),
          align: 'left',
          width: '150px',
          dataIndex: 'lockOperateNum',
        },
        {
          title: this.$t('custTrans.regSuccessRateByTime'),
          width: '150px',
          align: 'left',
          dataIndex: 'successRateByTime',
        },
        {
          title: this.$t('custTrans.regSuccessRateByMobile'),
          align: 'left',
          width: '150px',
          dataIndex: 'successRateByMobile',
        },
      ]
    },
  },
  created() {
    getApplist().then((res) => {
      this.appList = res.data || []
    })
    this.loadData(1)
  },
  methods: {
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.form.pageNum = 1
      }
      // this.loading = true
      var params = this.getQueryParams() // Query conditions
      getReportDay(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.dataSource = res.data
            this.dataSource.forEach((item) => {
              if (item.id == 0) {
                item.statisticDate = this.$t('components.total')
              } else {
                item.statisticDate = this.transformTime(item.statisticDate)
              }
              item.avgSubNum = (Math.round(item.avgSubNum * 100) / 100).toFixed(2)
              item.avgSendNumEveryMobile = (Math.round(item.avgSendNumEveryMobile * 100) / 100).toFixed(2)
              item.transRate = (Math.round(item.transRate * 10000) / 100).toFixed(2) + '%'
              item.subValidMobileProportion = (Math.round(item.subValidMobileProportion * 10000) / 100).toFixed(2) + '%'
              item.successRateByTime = (Math.round(item.successRateByTime * 10000) / 100).toFixed(2) + '%'
              item.successRateByMobile = (Math.round(item.successRateByMobile * 10000) / 100).toFixed(2) + '%'
            })
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    transformTime(time) {
      const m = moment(time, 'YYYY-MM-DD', true)
      if (m.isValid()) {
        return m.format('DD-MM-YYYY')
      }
      return moment(time).format('DD-MM-YYYY')
    },
    getQueryParams() {
      const { examineDate } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: examineDate && examineDate[0].format('YYYY-MM-DD'),
        endDate: examineDate && examineDate[1].format('YYYY-MM-DD'),
      }
      delete data.examineDate
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // Reset dictionary type search box content
    searchReset() {
      var that = this
      that.queryParam.examineDate = [moment().add('days', -15), moment().add('days', -1)]
      that.queryParam.appSsids = ''
      this.loadData()
    },
    download() {
      var params = this.getQueryParams() // Query conditions
      var fileUrl = ''
      if (params.appSsids === undefined) {
        fileUrl =
          '/api/web/webpublic/reportDay/exportRegister?startDate=' + params.startDate + '&endDate=' + params.endDate
      } else {
        fileUrl =
          '/api/web/webpublic/reportDay/exportRegister?appSsids=' +
          params.appSsids +
          '&startDate=' +
          params.startDate +
          '&endDate=' +
          params.endDate
      }
      const file = {
        fileUrl: fileUrl,
        // fileUrl: '/api/web/webpublic/reportDay/exportRegister?appSsids=' + params.appSsids + '&startDate=' + params.startDate + '&endDate=' + params.endDate,
        fileName: 'RegisterMonitor_' + params.startDate + '_' + params.endDate + '.xls',
      }
      this.loading = true
      exportFile(file)
        .catch((e) => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
/deep/ .ant-table-thead > tr > th {
  white-space: nowrap;
}
</style>
